module.exports = __webpack_public_path__ + "img/athletics_icon_11.bb6996b9.png";